import React, { useEffect, useRef, useState } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Card, Col, FormGroup, Row } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import SupplierDetails from '../DetailFolder/SupplierDetails';
import { usePOTemplateOrderState } from '../AddPOTemplateProvider';

function SupplierFactoryTable({ element, eleIndex, dropLocation, fromForm }) {
  const cardRef = useRef(null);
  const { deleteCard, modfiyReqAndEnable, changeLabel } = usePOTemplateOrderState();
  const [supplierData, setSupplierData] = useState(null);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (!isEmpty(element)) {
      setSupplierData({ ...element });
    }
  }, [element]);

  const [{ itemDragging }] = useDrag({
    type: 'container',
    collect: (monitor) => ({
      itemDragging: monitor.getItem(),
    }),
  });

  const [{ cardOver, item }, drop] = useDrop({
    accept: 'container',
    drop: () => {
      dropLocation(eleIndex, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      cardOver: monitor.isOver(),
    }),
  });

  drop(cardRef);

  const onChangeSupplier = (value, label, i, _eleIndex, index) => {
    const template = [...supplierData.columns];
    if (template[index][i].options) {
      const updatedOptions = template[index][i].options.map((e) => {
        if (e.name === label) {
          return { ...e, value };
        }
        return e;
      });
      template[index][i].options = updatedOptions;
    } else {
      template[index][i].value = value;
    }
    setSupplierData((previosState) => ({
      ...previosState,
      columns: template,
    }));
  };

  const changePosition = (item, index, i) => {
    const dragedItem = item?.col;
    const newColumns = supplierData?.columns;
    newColumns[index].splice(i, 0, dragedItem);
    if (newColumns[item?.index][item?.i]?.id === newColumns[index][i]?.id) {
      newColumns[item?.index].splice(item?.i, 1);
    } else {
      newColumns[item?.index].splice(item?.i + 1, 1);
    }

    setSupplierData((previousData) => ({
      ...previousData,
      columns: newColumns,
    }));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div ref={cardRef}>
        {cardOver && <div className="potemplate-drag-placeholder">{t('COMPANY_DETAILS.DROP_SECTION')}</div>}
        <Card className="listing-card">
          <Card.Header className="px-2 py-2 bgcolor-dark d-flex">
            <strong onClick={() => changeLabel(supplierData, eleIndex)}>{supplierData?.label}</strong>
            {itemDragging?.type !== 'container' && (
              <>
                <button
                  className="btn btn-border ml-auto py-0 px-1"
                  name="edit"
                  type="button"
                  key={`${element?.key}_${eleIndex}_edit`}
                  onClick={() => modfiyReqAndEnable(supplierData, eleIndex)}
                >
                  <span className="icon-edit" />
                </button>
                <button className="btn btn-border py-0 px-1" key={`${element?.key}_${eleIndex}_delete`} type="button" onClick={() => deleteCard(eleIndex)}>
                  <span className="icon-delete" />
                </button>
              </>
            )}
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body className="py-4">
              <Row className="span_font_size">
                {supplierData?.columns?.map((column, index) => {
                  return (
                    <Col lg={6} key={index}>
                      {column?.map((col, i) => {
                        return (
                          <FormGroup key={col?.key}>
                            <SupplierDetails
                              col={col}
                              index={index}
                              i={i}
                              onChange={onChangeSupplier}
                              eleIndex={eleIndex}
                              changePosition={changePosition}
                              supplierData={supplierData}
                              fromForm={fromForm}
                            />
                          </FormGroup>
                        );
                      })}
                    </Col>
                  );
                })}
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    </DndProvider>
  );
}

export default SupplierFactoryTable;
